export default __webpack_public_path__ + "static/media/seller_collection_agency_transactions.cc4202f8.xlsx";